import {Flex} from 'antd';
import React from 'react';

const PopupFlex: React.FC<{
  mapData: any;
  isNegative: boolean;
}> = ({mapData}) => {
  return (
    <Flex vertical gap={10}>
      <div className="emission">
        <div className="emissionValue">
          {`${mapData?.emissions?.value} `}
          <span className="emissionValueUnit">{mapData?.emissions?.unit}</span>
        </div>
      </div>
        <div className="facilityName">{mapData?.name}</div>
    </Flex>
  );
};

export default PopupFlex;
